/** The Overview's line icons, drawn rather than taken from a font so they
 *  sit on the text's centre line and take the text's colour. */

export function ArrowIcon() {
  return <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 15 15 5M5 5h10v10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
}

export function RefreshIcon() {
  return <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M16.5 8a6.5 6.5 0 1 0-.8 5M16.5 3v5h-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
}

export function SearchIcon() {
  return <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.5" /><path d="m13 13 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
}

export function FlagIcon() {
  return <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 18V3c4-3 7 3 12 0v9c-5 3-8-3-12 0" /></svg>
}
